import { Outlet } from 'react-router-dom';
import { Plane } from 'lucide-react';

export function AuthLayout() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-primary shadow-lg shadow-blue-500/30 mb-4">
            <Plane className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900">FlightSync Pro</h1>
          <p className="text-gray-600 mt-1">智能航班日程同步平台</p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <Outlet />
        </div>

        {/* Footer */}
        <div className="text-center mt-6 space-y-1">
          <p className="text-sm text-gray-500">© 2025 FlightSync Pro. All rights reserved.</p>
          <p className="text-xs text-gray-400">
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-600 transition-colors"
            >
              渝ICP备2026015661号
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
